import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';

import { useExtrapolation } from './useExtrapolation';

export function useExtrapolationTransport(
  statsPublic: ImpactCo2AnswerStatsPublic,
) {
  const personCount = statsPublic.publicMobilitySumTotalPassengerCount;
  return useExtrapolation(statsPublic, personCount, applyExtrapolation);
}

function applyExtrapolation(
  statsPublic: ImpactCo2AnswerStatsPublic,
  f: number,
): ImpactCo2AnswerStatsPublic {
  return {
    ...statsPublic,
    publicMobilitySumTotalPassengerCount: Math.round(
      statsPublic.publicMobilitySumTotalPassengerCount * f,
    ),
    publicMobilitySumTotalTravelDistance: Math.round(
      statsPublic.publicMobilitySumTotalTravelDistance * f,
    ),
    publicMobility: statsPublic.publicMobility.map((x) => ({
      ...x,
      totalPassengerCount: Math.round(x.totalPassengerCount * f),
      totalTravelDistance: Math.round(x.totalTravelDistance * f),
      totalScore: x.totalScore * f,
    })),
  };
}
